export enum PaymentTabsEnum {
  PAYMENT_INFORMATION = 'payment-information',
  PAYMENT_AMOUNT = 'payment-amount',
}
